/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class RepeatingTextBlockIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="56"
      viewBox="0 0 70 56"
      fill="none"
    >
      <rect
        x="3"
        y="7"
        width="25"
        height="5"
        rx="2.5"
        fill="#C4C4C4"
      />
      <rect
        x="3"
        y="15"
        width="64"
        height="4"
        rx="2"
        fill="#C4C4C4"
      />
      <rect
        x="3"
        y="22"
        width="25"
        height="5"
        rx="2.5"
        fill="#C4C4C4"
      />
      <rect
        x="3"
        y="30"
        width="64"
        height="4"
        rx="2"
        fill="#C4C4C4"
      />
      <rect
        x="3"
        y="37"
        width="25"
        height="5"
        rx="2.5"
        fill="#C4C4C4"
      />
      <rect
        x="3"
        y="45"
        width="64"
        height="4"
        rx="2"
        fill="#C4C4C4"
      />
    </svg>;
  }
}

const Icon = pure(RepeatingTextBlockIcon);
Icon.displayName = 'RepeatingTextBlockIcon';
export { Icon as RepeatingTextBlockIcon };
